var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:("alert  alert--" + (_vm.props.type || 'info'))},[_vm._v("\n  "+_vm._s(_vm.props.message || '')+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }